import React from 'react';
import ReactDOM from 'react-dom';
import { createMuiTheme } from '@material-ui/core/styles';
import { SvgIcon } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css'
import landingPageImg from './landing-page-img.svg'

import { initStaq, withStaq } from '@staqjs/client'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#24C6EF',
    },
    secondary: {
      main: '#354147',
    },
  },
  typography: {
    h1: {
      fontFamily: '"Montserrat", sans-serif'
    }
  }
})

const Logo = (props) => {
  return (
    <SvgIcon viewBox="0 0 30 30" style={{ marginRight: 10 }}>
      <path d="M30 23.75H10V30H30V23.75Z" fill="#22C6F0"/>
      <path d="M20 11.875H0V18.125H20V11.875Z" fill="#22C6F0"/>
      <path d="M30 0H10V6.25H30V0Z" fill="#22C6F0"/>
    </SvgIcon>
  )
}

initStaq({
  theme,
  logo: Logo,
  siteTitle: 'Staq Live Demo',
  landingPageHeader: 'This site is built w/ Staq',
  landingPageSubheader: 'Landing page, user flows, and subscription billing in < 100 lines of code',
  landingPageImage: landingPageImg,
  copyright: '2020 StaqJS',
  poweredByStaq: true,
  featureSectionTitle: 'Say goodbye to SaaS boilerplate',
  features: [
    { title: 'Simple', text: 'A clean API that handles the boring stuff for you' },
    { title: 'Unlimited', text: 'Create as many SaaS apps as you want for free' },
  ],
  pricingSectionTitle: 'Simple pricing for a simple tool',
  pricingSectionSubheader: '* Pricing cards for demo purposes only. StaqJS is 100% free and open source.',
  plans: [
    {
      name: 'Free',
      price: '0',
      features: [
        'A basic amount of features'
      ]
    },
    {
      name: 'Pro',
      price: '10',
      features: [
        'More features'
      ]
    }
  ],
  footerColumns: [
    {
      title: 'Company',
      links: [
        { text: 'Terms and Conditions', link: '/terms' },
        { text: 'Privacy Policy', link: '/privacy' },
      ]
    },
    {
      title: 'Contact',
      links: [
        { text: 'matt@staqjs.com', link: 'mailto:matt@staqjs.com' }
      ]
    },
  ],
  firebaseConfig: {
    apiKey: "AIzaSyA53q0l3Q68T6R19imxXl9SHOGxfHGhdOM",
    authDomain: "staq-live-demo.firebaseapp.com",
    databaseURL: "https://staq-live-demo.firebaseio.com",
    projectId: "staq-live-demo",
    storageBucket: "staq-live-demo.appspot.com",
    messagingSenderId: "316093476373",
    appId: "1:316093476373:web:44a44c5cc8c5a1f782681c",
    measurementId: "G-05585GF15F"
  }
})

ReactDOM.render(
  withStaq(
    <ThemeProvider theme={theme}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ThemeProvider>
  ),
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
